import {ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";
import {CommonModule} from "@angular/common";
import {AlertComponent} from "./helpers/alert/alert.component";
import {TranslateModule} from "@ngx-translate/core";
import {AlertService} from "./services";
import {StandaloneDetailResolver} from "./services/details/standalonedetail.resolver";
import {SirenHelper} from "./helpers/siren.helper";
import {HalHelper} from "./helpers/hal.helper";
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {SafeUrlPipe} from "./pipes/safeurl.pipe";
import {ListingService} from "./services/listing/listing.service";
import {ListingConfigurationResolver} from "./services/listing/listing-configuration.resolver";
import {ListingContentsResolver} from "./services/listing/listing-contents.resolver";
import {DetailResolver} from "./services/details/detail.resolver";
import {DetailService} from "./services/details/detail.service";
import {ClickedOutsideDirective} from "./helpers/clicked-outside.directive";
import {AuthResolver} from "./services/authentication/auth.resolver";
import {ClientSelectionResolver} from "./services/client-selection/client-selection.resolver";
import {TabsModule} from "ngx-bootstrap/tabs";
import {AccordionModule} from "ngx-bootstrap/accordion";
import {ModalModule} from "ngx-bootstrap/modal";
import {ProfileResolver} from "./services/details/profile.resolver";

@NgModule({
	declarations: [
		AlertComponent,
		SafeUrlPipe,
        ClickedOutsideDirective
	],
	imports: [
		RouterModule,
		CommonModule,
		TranslateModule,
		TooltipModule.forRoot(),
	],
	exports: [
		RouterModule,
		AlertComponent,
		TranslateModule,
		TooltipModule,
        TabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AccordionModule,
        ModalModule,
		SafeUrlPipe,
        ClickedOutsideDirective
    ],
	providers: []
})
export class SharedModule
{

    // constructor (@Optional() @SkipSelf() parentModule: SharedModule) {
    //     if (parentModule) {
    //         throw new Error(
    //             'SharedModule is already loaded. Import it in the AppModule only');
    //     }
    // }

	// This is to create only one global instance of the providers when sharedModule is imported in app.module
	// vgl. https://www.softwarearchitekt.at/post/2016/09/03/lazy-loading-von-modulen-mit-angular-2-dem-neuen-router-und-webpack.aspx
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
            	AlertService,
                StandaloneDetailResolver,
                SirenHelper,
                HalHelper,
				ListingService,
				ListingConfigurationResolver,
				ListingContentsResolver,
				DetailService,
				DetailResolver,
				AuthResolver,
				ClientSelectionResolver,
				ProfileResolver
            ]
        };
    }


} // end class SharedModule
